export const SET_THREADS_SUCCESS = 'SET_THREADS_SUCCESS';
export const UPDATE_THREAD_CURRENT_URL = 'UPDATE_THREAD_CURRENT_URL';